import { render, staticRenderFns } from "./tablaPdf.vue?vue&type=template&id=54e17176&"
import script from "./tablaPdf.vue?vue&type=script&lang=js&"
export * from "./tablaPdf.vue?vue&type=script&lang=js&"
import style0 from "./tablaPdf.vue?vue&type=style&index=0&id=54e17176&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports